module.exports = __webpack_public_path__ + "static/media/Pool-Party-Logo.9ae4d36b.png";